import React, { Component } from "react";
import ReactDOM from 'react-dom';
import ReplaceDossier from './ReplaceDossier';
import ShareDocuments from './ShareDocuments';
import SimplePagination from "./SimplePagination";
import TransferInternalDossier from "./TransferInternalDossier";
import SuspendRecurrencyModal from "./SuspendRecurrencyModal";
import DeletePeriodsModal from "./DeletePeriodsModal.jsx"
import GeneratePeriodsModal from "./GeneratePeriodsModal.jsx"
import ReplaceDocumentTemplante from "./ReplaceDocumentTemplate.jsx";
import DeletePersonDocumentsModal from "./DeletePersonDocumentsModal.jsx";
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
class DossierActions extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.currentHistoryId = 0;
        this.state = {
            aditionalDocuments:[],
            addDocuments:[],
            onceDocuments:[],
            recurrentDocuments:[],
            doc2SignDocuments: [],
            showSharedocuments:false,
            sharedUsers:[],
            documentType:'new',
            personProvider:[],
            page: 1,
            pageOnce:1,
            maxRecords: 10,
            document_dossier_update_state:2,
            from_document_dossier_update_state:1,
        };
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadMoreAdditionalDossierDocuments = this.loadMoreAdditionalDossierDocuments.bind(this);
        this.suspendRecurrencyModalRef = React.createRef();
        this.deletePeriodsModalRef = React.createRef();
        this.deletePersonDocumentsRef = React.createRef();
        this.generatePeriodsModalRef = React.createRef();
        this.replaceDocumentTemplateRef = React.createRef();
    }
    
    
    openSuspendeModal = (state, from) => {
        this.setState({
            document_dossier_update_state: state,
            from_document_dossier_update_state: from
        }, () => {
            if (this.suspendRecurrencyModalRef.current) {
                this.suspendRecurrencyModalRef.current.handleOpenModalSuspend();
            }
            $('#suspendRecurrencyModal').modal('show');
        });
    }
    openReplaceDocumentModal = ()=>{
        if(this.replaceDocumentTemplateRef.current){
            this.replaceDocumentTemplateRef.current.handleOpenModalReplaceDocument();
        }
    }
    openDeletePeriodsModal = () => { 
        if (this.deletePeriodsModalRef.current) {
            this.deletePeriodsModalRef.current.handleOpenModalDeletePeriods();
        } 
    }
    openDeletePersonDocumentsModal = () => {  
        if (this.deletePersonDocumentsRef.current) {
            this.deletePersonDocumentsRef.current.handleOpenModalDeletePersonDocuments();
        } 
    } 
    openGeneratePeriodsModal = () => {
        if (this.generatePeriodsModalRef.current) {
            this.generatePeriodsModalRef.current.handleOpenModalGeneratePeriods();
        }
    } 
    
    isChecked = (e)=>{
        for(let i=0; i<this.state.aditionalDocuments.length; i++){
            if(this.state.aditionalDocuments[i].id == e.id){
                return true;
            }
        }
    }

    getData = ()=>{ 
        
        this.setState({showSharedocuments:true })
    }

    handleTypeChange = (e) => {
        // If the previous section is Doc2Sign we need to remove the
        // additional documents selected in the Doc2Sign section.
        if (this.state.documentType == 'doc2sign' && e.target.value != 'doc2sign') {
            this.setState({ aditionalDocuments: [] });
        }

        this.setState({ documentType: e.target.value })

        if (e.target.value == 'doc2sign') {
            this.setState({ aditionalDocuments: [] });

            this.setState({page: 1}, function () {
                this.getDossierAdditionalDocuments(1, null, this.state.maxRecords);
            });
        } else {
            this.setState({page: 1}, function () {
                this.getAditionalDocuments();
            });
        }
    }

    /**
     * Get all the additional Doc2Sign invitation dossier documents.
     *
     * @todo Support "New documents" and "Existing Documents" sections in the endpoint.
     * @todo Attach the new documents to the existing ones.
     *
     * @param   {integer} pageNumber
     * @param   {string} search
     * @param   {integer} pageSize
     */
    async getDossierAdditionalDocuments(pageNumber, search, pageSize) {
        const response = await axios.get(`/api/invitations/additional-documents`, {
            params: {
                'include': 'mimes',
                'page[number]': pageNumber,
                'page[size]': pageSize,
                'filter[search]': search,
                'sort': '-created_at',
            }
        });

        this.setState({
            doc2SignDocuments: response.data.data,
            total: response.data.meta.total,
        });
    }

    /**
     * Load more additional Doc2Sign invitation dossier documents.
     *
     * @todo Support "New documents" and "Existing Documents" sections in the endpoint.
     * @todo Attach the new documents to the existing ones.
     *
     * @param   {integer} page
     */
    loadMoreAdditionalDossierDocuments(page) {
        this.setState({page: page}, function () {
            this.getDossierAdditionalDocuments(page, this.state.search, this.state.maxRecords);
        });
    }

    searchAdditionalDossierDocument(e) {
        this.setState({page: 1, search: e.target.value}, function () {
            this.getDossierAdditionalDocuments(this.state.page, this.state.search, this.state.maxRecords);
        });
    }

    /**
     * Handle additional document selection.
     *
     * @todo Support "New documents" and "Existing Documents" sections.
     * @todo Fix "aditional" typo to "additional".
     *
     * @param   {object} document
     */
    additionalDocumentSelected(e, document) {
        this.setState({
            aditionalDocuments: [document],
        });
    }

    /**
     * Asynchronously redirects the user to the Doc2Sign upload widget for additional documents.
     * If there are no additional documents to upload, the method returns without performing any action.
     * The method uses axios to fetch the Doc2Sign upload widget URL for a specific document and invitation.
     * After retrieving the URL, it redirects the user to that URL using the window.location.href property.
     * The method also uses the window.blockUI() and window.unblockUI() functions to block and unblock
     * the user interface during the process.
     *
     * @throws {Error} If there's an issue with fetching the Doc2Sign upload widget URL.
     */
    async redirectToDoc2SignUploadWidget() {
        if (this.state.aditionalDocuments <= 0) {
            return;
        }

        window.blockUI();

        try {
            const personProviderId = this.props.person_provider_id;
            const documentId = this.state.aditionalDocuments[0].id;

            const response = await axios.get(`/api/invitations/${personProviderId}/documents/${documentId}/upload-doc2sign-widget`);

            window.location.href = response.data.data.url;
        } catch (error) {
            throw new Error('Failed to fetch the Doc2Sign upload widget URL.');
        } finally {
            window.unblockUI();
        }
    }

    openModal(){ 
        $('[name="search"]').val('');
        this.setState({search: ''}, () => {
            this.getAditionalDocuments();
        })
    }


    openReplaceModal = ()=>{
        if (this.childRefReplace) {
            this.childRefReplace.handleOpenModalReplace();
        }
        $('#replaceDossiers').modal('show')
    }
    async getAditionalDocuments() {
        this.setState({
            addDocuments: []
        })
        this.setState({
            onceDocuments: []
        })
        var url = '/api/documents/filter_aditional_2';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('pageOnce', this.state.pageOnce)
        query.append('dossier_id', this.props.dossier_id)
        query.append('maxRecords', this.state.maxRecords)
        query.append('search', this.state.search)
        query.append('person_provider_id', this.props.person_provider_id)

        const qs = query.toString();
        const res =  await axios.get(url+`?${qs}`);
        const once = res.data.once.data
        const data = res.data.recurrents.data;
        this.setState({addDocuments: data, total: res.data.recurrents.total});
        this.setState({onceDocuments: once, totalOnce: res.data.once.total});
        this.setState({recurrentDocuments: once, totalOnce: res.data.recurrents.data});
    }
    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAditionalDocuments();
        });
    }
    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getAditionalDocuments();
        });
    }
    updateCurrentPageOnce(page){
        this.setState({pageOnce: page}, function () {
            this.getAditionalDocuments();
        });
    }

    SetNotificationStatus(){
        const { lang } = this.context;
        let that = this
        Swal.fire({
            html: '<b>'+ lang.get('messages.desear_notificar_al_invitado') +'</b></br>',
            icon: "info",
            buttonsStyling: false,
            confirmButtonText:lang.get('messages.notificar_y_enviar_nueva_solicitud'),
            showCancelButton: true,
            cancelButtonText: lang.get('messages.no_notificar_y_enviar_nueva_solicitud'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            },

        }).then(function(result) {
            if(result.dismiss != 'backdrop'){
                if(result.isConfirmed){ 
                    that.addDocumentstoDossier(true)
                }else{
                    that.addDocumentstoDossier(false)
                }
            }
        });
    }
    async addDocumentstoDossier(SendNotificationToProvider){
        const { lang } = this.context;
        const params = JSON.stringify({
            additional_documents: this.state.aditionalDocuments,
            dossier_id: this.props.dossier_id,
            person_provider_id:this.props.person_provider_id,
            send_notification_to_provider:SendNotificationToProvider,
        })
        await axios.post(
            '/api/documents/add_new_documents',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            let containsOnceDocuments = this.state.aditionalDocuments.some(obj => obj.hasOwnProperty('document'));
                Swal.fire({
                    html: '<b>'+ lang.get('messages.confirmacion') +'</b></br>'+  lang.get('messages.se_ha_solicitado_un_nuevo_documento_unico_a_tu_expediente') + '.',
                    icon: "info",
                    buttonsStyling: false,
                    confirmButtonText:lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                    timer: 3000
                }).then(function(result) {
                    location.reload()
                });
            this.setState({
                aditionalDocuments: []
            })
        })
    }

    deleteDossier = ()=>{
        const { lang } = this.context;
        let data = {
            'id':this.props.person_provider_id
        }
        swal.fire({
            text:  lang.get('messages.estas_seguro_que_deseas_eliminar_este_expediente'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('/api/dossiers/delete_dossier',data).then(res=>{
                    swal.fire({
                        text: lang.get('messages.expediente_eliminado'),
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText: lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        window.location.href = '/client';
                    });
                })
            }
        });

    }

    openReplaceModal = ()=>{
        if (this.childRefReplace) {
            this.childRefReplace.handleOpenModalReplace();
        }
        $('#replaceDossiers').modal('show')
    }
   
    openTransferInternalDossierModal = ()=>{
        if (this.childRef) {
            this.childRef.handleOpenModal();
        }
        $('#modal-transferir').modal('show')
    }
    updateStateList(e, value){
            if (e.target.checked){
                    this.setState({
                        aditionalDocuments: this.state.aditionalDocuments.concat([value])
                    })
                } else {
                this.setState({
                    aditionalDocuments : this.state.aditionalDocuments.filter(function(val)
                        {
                            return val.id!==value.id
                        }
                    )
                })
            }
        }
    render() {
        const { lang } = this.context;
        const dossierActions = this.props.type == 2
            ? (this.props.permissions?.dossiers_actions_internal || [])
            : (this.props.type == 3
                ? (this.props.permissions?.dossiers_actions_own || [])
                : (this.props.permissions?.dossiers_actions || []));
        const hasDossierAction = (action) => dossierActions.includes('all') || dossierActions.includes(action);
        const hasProviderAction = (action) => this.props.permissions?.providers?.includes('all') || this.props.permissions?.providers?.includes(action);
        const canShowDeleteMenu = hasDossierAction('delete') || hasDossierAction('delete_documents') || hasDossierAction('delete_document_requests') || hasDossierAction('delete_document_request');

        return (<div className="d-flex align-items-center flex-wrap">
        {  (hasDossierAction('request')
        || hasDossierAction('download')
        || hasDossierAction('stop_recurrence')
        || hasDossierAction('start_recurrence')
        || hasDossierAction('replace_dossier')
        || hasDossierAction('generate_historic')
        || hasDossierAction('replace_template')
        || hasDossierAction('share')
        || canShowDeleteMenu
        || hasProviderAction('resend_invitation')
        || hasProviderAction('delete_invitations') )&&
            <div className="dropdown dropdown-inline">
                <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {lang.get('messages.acciones')}
                    &nbsp;&nbsp;
                    <i className="flaticon2-down icon-sm"></i>
                </a>
                <div className="dropdown-menu  dropdown-menu-actions dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg" style={{ background: '#F0E9FF' }}>
                    <ul className="navi navi-hover">
                        { this.state.detail?.status.toLowerCase() == "invitado" ?
                        <>
                            {hasProviderAction('resend_invitation') && (
                            <li className="navi-item li-actions">
                                <span role="button" onClick={() => this.resendInvitation()}  className="navi-link py-4 cursor">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon2-mail text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary">{lang.get('messages.reenviar_invitacion')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </span>
                            </li>
                            )}
                            {hasProviderAction('delete_invitations') && (
                            <li className="navi-item li-actions">
                                <span role="button" onClick={()=>{ this.confirmDelete() }}  className="navi-link py-4 cursor">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon-delete fw-normal text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary">{lang.get('messages.borrar_invitacion')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </span>
                            </li>
                            )}
                        </>
                        :
                            ""
                        }
                        { this.state.detail?.status.toLowerCase() != "invitado" &&
                        <>
                            {  hasDossierAction('request') &&
                            <li className="navi-item li-actions">
                                <a href="" onClick={this.openModal.bind(this)} className="navi-link py-4" data-toggle="modal" data-target="#modal">
                                    <i className="icon-md mr-2  text-primary flaticon2-paper"  ></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.solicitar_documento')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            } 

                            {  ( this.props.transfer == false ) &&
                            <>
                                <li className="navi-item li-actions">
                                    <a onClick={()=>{ this.openTransferInternalDossierModal() }}  className={`navi-link py-4 ${this.props.actions_enabled != '1'  && 'disabled'}`} data-toggle={this.props.actionsenabled == 1 ? "modal" : ""}  data-target="#modal-transferir">
                                    <i className="icon-md mr-2 text-primary flaticon2-refresh"  ></i>
                                        <span className="navi-text text-secondary">{lang.get('messages.transferir')} {this.props.transfer} </span>
                                        <span className="navi-icon pull-right">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </span>
                                    </a>
                                </li>

                            </>
                            }
                            {  hasDossierAction('download') &&
                            <li className="navi-item li-actions">
                                <a onClick={() => {
                                if ( this.props.ids.length > 0 ) {
                                    window.location.href = '/files/download/[' + this.props.ids + ']';
                                }
                                }} className={`navi-link py-4 ${this.props.ids?.length == 0 && 'disabled'}`}  >
                                    <i className="icon-md mr-2  text-primary flaticon-folder-2"  ></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.descargar_expediente_completo')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            }
                            {  hasDossierAction('share') &&
                            <li className="navi-item li-actions">
                                <a onClick={()=>{ this.getData() }}  className="navi-link py-4"  >
                                <i className="icon-md mr-2  text-primary   flaticon-share"  ></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.compartir_documentos')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            }
                              {  hasDossierAction('stop_recurrence') &&
                            <li className="navi-item li-actions">
                                <a onClick={()=>{ this.openSuspendeModal(2,1) }} className="navi-link py-4" data-toggle="modal" data-target="#suspendModal"  >
                                <i className="icon-md mr-2  text-primary   flaticon-stopwatch"></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.suspender_recurrencia')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span> 
                                </a>
                            </li>
                            }
                            {  hasDossierAction('start_recurrence') &&
                            <li className="navi-item li-actions">
                                <a onClick={()=>{ this.openSuspendeModal(1,2) }} className="navi-link py-4" data-toggle="modal" data-target="#suspendModal"  >
                                <i className="icon-md mr-2  text-primary flaticon-time "></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.reactivar_recurrencia')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span> 
                                </a>
                            </li>
                            }
                            
                            { 
                                hasDossierAction('replace_dossier') 
                                ? (
                                    this.props.actions_enabled === true && this.props.type !== 3 && (
                                        <li className="navi-item li-actions">
                                        <a onClick={() => this.openReplaceModal()} className="navi-link py-4">
                                            <i className="icon-md mr-2 text-primary weight-normal flaticon2-cube-1"></i>
                                            <span className="navi-text text-secondary">
                                            {this.state.personProvider.type} {lang.get('messages.reemplazar_expediente')}
                                            </span>
                                            <span className="navi-icon pull-right">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                            </span>
                                        </a>
                                        </li>
                                    )
                                    )
                                : null
                                }
                        </>
                        }
                        {  hasDossierAction('generate_historic') &&
                        <li className="navi-item li-actions">
                            <a onClick={()=>{ this.openGeneratePeriodsModal(1,2) }} className="navi-link py-4" data-toggle="modal" data-target="#GeneratePeriodsModal"  >
                            <i className="icon-md mr-2  text-primary flaticon2-calendar-9"></i>
                                <span className="navi-text text-secondary">Generar documentos historicos</span>
                                <span className="navi-icon pull-right">
                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                    </button>
                                </span> 
                            </a>
                        </li>
                        }
                        {  hasDossierAction('replace_template') &&
                        <li className="navi-item li-actions">
                            <a onClick={()=>{ this.openReplaceDocumentModal() }} className="navi-link py-4" data-toggle="modal"    >
                            <i className="icon-md mr-2  text-primary flaticon-interface-4"></i>
                                <span className="navi-text text-secondary">Reemplazar plantilla de documento</span>
                                <span className="navi-icon pull-right">
                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                    </button>
                                </span> 
                            </a>
                        </li>
                        }
                        
                        {canShowDeleteMenu && (
                        <li className="navi-item li-actions">
                            <a className="navi-link py-4">
                                <i className="icon-md mr-2 text-primary weight-normal flaticon-delete"></i>
                                <span className="navi-text text-secondary">Borrar</span>
                                <span className="navi-icon pull-right">
                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                        <i className="flaticon2-down weight-normal text-primary icon-sm"></i>
                                    </button>
                                </span> 
                            </a>
                            <ul className="dropdown-menu">
                            { this.state.detail?.status.toLowerCase() != "invitado" &&
                            <>
                            {  hasDossierAction('delete') &&
                            <li className="navi-item over li-actions">
                                <a onClick={()=>{ this.deleteDossier() }}  className="navi-link py-4"  >
                                <i className="icon-md mr-2  text-primary weight-normal flaticon-delete"></i>
                                    <span className="navi-text text-secondary">{lang.get('messages.borrar_expediente')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            }
                            </>
                            }
                            {this.props.showDeleteDocumentsModal && hasDossierAction('delete_documents') && 
                            <>
                                <li className="navi-item   over">
                                    <a onClick={()=>{ this.openDeletePersonDocumentsModal() }} className="navi-link py-4" data-toggle="modal" data-target="#deletePersonDocumentsModal"  >
                                    <i className="icon-md mr-2  text-primary  weight-normal flaticon-delete "></i>
                                        <span className="navi-text text-secondary">Borrar documento(s)</span>
                                        <span className="navi-icon pull-right">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </span> 
                                    </a>
                                </li> 
                            </>
                            } 
                            {(hasDossierAction('delete_document_requests') || hasDossierAction('delete_document_request')) && (
                                <li className="navi-item over">
                                    <a 
                                        onClick={() => { this.openDeletePeriodsModal() }} 
                                        className="navi-link py-4 d-flex align-items-center" 
                                        data-toggle="modal" 
                                        data-target="#deletePeriodsModal"
                                    >
                                        <i className="icon-md mr-2 text-primary weight-normal flaticon-delete"></i>
                                        <div className="d-flex flex-column">
                                            <span className="navi-text text-secondary">Borrar solicitud de documento(s)</span> 
                                            <span className="text-muted">(con frecuencia mensual)</span>
                                        </div> 
                                        <span className="navi-icon ml-auto">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </span> 
                                    </a>
                                </li>
                            )}
                            </ul>
                        </li>
                        )} 
                    </ul>
                </div>
            </div>
        }
        {
            (this.state.showSharedocuments == true &&  <ShareDocuments
                ref={ref => (this.childRefShare = ref)}
                url={this.props.url} detail={this.state.detail} sharedUsers={this.state.sharedUsers} dossier_id={this.props.dossier_id} person_provider_id={this.props.person_provider_id}/>
            )
        }
        <ReplaceDossier ref={ref => (this.childRefReplace = ref)} permissions={this.props.permissions} person_provider_id={this.props.person_provider_id} url={this.props.url} detail={this.state.detail} sharedUsers={this.state.sharedUsers} dossier_id={this.props.dossier_id} dossier_name={ this.props.dossier_name } is_internal={false}/>
        <TransferInternalDossier  ref={ref => (this.childRef = ref)} person_provider_id={this.props.person_provider_id}  />
        
        <div className="modal fade"   id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content" style={{ background: '#f5f5f5' }}>
                    <div className="modal-body px-15 py-10">
                        <h5 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.solicitar_nuevos_documentos')}</h5>
                        <div className="text-muted">{lang.get('messages.selecciona_si_los_documentos_que_vas_a_solicitar_son_documentos_nuevos_existentes_en_tu_expediente_o_requieren_firma_electronica')}</div>
                        <div className=" mt-5 d-flex">
                            <div className={ this.state.documentType == 'new' ? 'font-size-h5 selectedRadio mr-3' : 'mr-3 font-size-h5'}>
                                <input
                                    id="radio-new"
                                    type="radio"
                                    value="new"
                                    checked={this.state.documentType == 'new'}
                                    onChange={this.handleTypeChange}
                                />
                                <label
                                    htmlFor="radio-new"
                                    className="ml-1"
                                >
                                    {lang.get('messages.documentos_nuevos')}
                                </label>
                            </div>
                            <div className={ this.state.documentType == 'once' ? 'font-size-h5 selectedRadio mr-3' : 'font-size-h5'}>
                                <input
                                    id="radio-once"
                                    type="radio"
                                    value="once"
                                    checked={this.state.documentType == 'once'}
                                    onChange={this.handleTypeChange}
                                />
                                <label
                                    htmlFor="radio-once"
                                    className="ml-1"
                                >
                                    {lang.get('messages.documentos_existentes')}
                                </label>
                            </div>

                            {this.props.has_doc_2_sign_enabled == 'true' &&
                                <div className={this.state.documentType == 'doc2sign' ? 'ml-3 font-size-h5 selectedRadio' : 'ml-3 font-size-h5'}>
                                    <input
                                        id="radio-doc2sign"
                                        type="radio"
                                        value="doc2sign"
                                        checked={this.state.documentType == 'doc2sign'}
                                        onChange={this.handleTypeChange}
                                    />
                                    <label
                                        htmlFor="radio-doc2sign"
                                        className="ml-1"
                                    >
                                        {lang.get('messages.documentos_con_firma_electronica')}
                                    </label>
                                </div>
                            }
                        </div>

                        {/* TODO: Create separate components for each document type */}
                        {this.props.has_doc_2_sign_enabled == 'true' && this.state.documentType == 'doc2sign' &&
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-header border-0 pt-6">
                                    <h3 className="col-8 card-title align-items-start flex-column">
                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_documentos_que_requieren_de_firma_electronica')}</span>
                                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles_selecciona_los_nuevos_documentos_que_seran_agregados_a_este_expediente')}</span>
                                    </h3>
                                    <div className="row col-4 justify-content-end">
                                        <div className="col-12">
                                            <div className="input-icon">
                                                <input
                                                    name="search"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buscar"
                                                    onChange={(e)=> this.searchAdditionalDossierDocument(e)}
                                                />
                                                <span>
                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body pt-5">
                                    {this.state.doc2SignDocuments.map((document, index) =>
                                        <div className="d-flex align-items-center py-2 mb-5">
                                            <div className="symbol symbol-40 symbol-white">
                                                <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                    <div className="radio-inline mr-5">
                                                        <label className="radio radio-outline mb-7">
                                                            <input
                                                                type="radio"
                                                                name="doc2signDocument"
                                                                value={document.id}
                                                                onChange={(e) => this.additionalDocumentSelected(e, document)}
                                                            />
                                                            <span className="w-25px h-25px mt-2 rounded-circle"></span>
                                                        </label>
                                                    </div>
                                                </span>
                                            </div>
                                            <div className="d-flex flex-grow-1 my-lg-0 my-2 mr-2">
                                                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <rect x="0" y="0" width="24" height="24" />
                                                        <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#844AFF" />
                                                        <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519)" x="16.3255682" y="2.94551858" width="3" height="18" rx="1" />
                                                    </g>
                                                </svg>
                                                <div className="d-flex flex-column ml-5">
                                                    <a
                                                        href={`/documents/${document.id}/edit`}
                                                        className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"}
                                                    >
                                                        <span className="text-danger font-weight-bold">* </span> {document.title}
                                                    </a>
                                                    <span className="text-muted font-weight-bold">{document.frequency == 'once' ? 'Único' : 'Recurrente'} |&nbsp;
                                                        {
                                                            document.mimes.map((mime, i, {length}) => {
                                                                if (length - 1 === i) {
                                                                    return mime.mime.toUpperCase()
                                                                } else {
                                                                    return mime.mime.toUpperCase() + ', '
                                                                }
                                                            })
                                                        }
                                                    </span> 
                                                </div>
                                            </div>
                                            <a href={`/documents/${document.id}/edit`}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className={"flaticon2-right-arrow icon-sm"}></i>
                                                </button>
                                            </a>
                                        </div>
                                    )}

                                    {this.state.total > this.state.maxRecords &&
                                        <SimplePagination
                                            updateCurrentPage={this.loadMoreAdditionalDossierDocuments}
                                            currentPage={this.state.page}
                                            totalFiles={this.state.total}
                                            split={this.state.maxRecords}
                                        />
                                    }
                                </div>
                            </div>
                        }

                        { this.state.documentType == 'new' &&
                        <div className="card card-custom gutter-b my-5">
                            <div className="card-header border-0 pt-6">
                                <h3 className="col-8 card-title align-items-start flex-column">
                                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_documentos')}</span>
                                    <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles_selecciona_los_nuevos_documentos_que_seran_agregados_a_este_expediente')}</span>
                                </h3>
                                <div className="row col-4 justify-content-end">
                                    <div className="col-12">
                                        <div className="input-icon">
                                            <input onChange={(e)=>this.handleChange(e)} name="search"type="text" className="form-control" placeholder={lang.get('messages.buscar')} />
                                            <span>
                                                <i className="flaticon2-search-1 text-primary icon-md"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-5">
                                {this.state.addDocuments.map((o, i) => {
                                return <div key={i}>
                                    <div className="d-flex align-items-center py-2 mb-5">
                                        <div className="symbol symbol-40 symbol-white">
                                            <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                            <div className="checkbox-inline mr-5">
                                                <label className="checkbox checkbox-outline mb-7">
                                                    <input key={o}
                                                    name='list'
                                                    type='checkbox'
                                                    defaultChecked={this.isChecked(o)}
                                                    onClick={(e)=>this.updateStateList(e,o)}
                                                    label='Add'
                                                    className='listTour'/>
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                </label>
                                            </div>
                                            </span>
                                        </div>
                                        <div className="d-flex   flex-grow-1 my-lg-0 my-2 mr-2">
                                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <rect x="0" y="0" width="24" height="24" />
                                                <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#844AFF" />
                                                <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519)" x="16.3255682" y="2.94551858" width="3" height="18" rx="1" />
                                            </g>
                                        </svg>
                                        <div className="d-flex flex-column ml-5">
                                            <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.fields.length > 0 && <span className="text-danger font-weight-bold">* </span> }{o.title} {o.fields.length > 0 && <span className="text-muted font-weight-normal">
                                                ( {lang.get('messages.con_informacion_adicional')})</span> }
                                            </a>
                                            <span className="text-muted font-weight-bold"> {o.frequency == 'once' ? lang.get('messages.unico'):lang.get('messages.recurrente')} |&nbsp;
                                                {
                                                    o.mimes.map((mime, i, {length}) => {
                                                        if (length - 1 === i) {
                                                            return mime.mime.toUpperCase()
                                                        } else {
                                                            return mime.mime.toUpperCase() + ', '
                                                        }
                                                    })
                                                }
                                            </span>
                                            </div>
                                            {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                        </div>
                                        <a href={"/documents/" + o.id + "/edit"}>
                                            <button className="btn btn-icon btn-light btn-xs">
                                                <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                            </button>
                                        </a>
                                    </div>
                                </div> })}
                                {this.state.total > this.state.maxRecords  &&
                                    <SimplePagination
                                    updateCurrentPage={this.updateCurrentPage}
                                    currentPage={this.state.page}
                                    totalFiles={this.state.total}
                                    split={this.state.maxRecords} />
                                }
                            </div>
                        </div>
                        }
                        { this.state.documentType == 'once' &&
                        <div className="card card-custom gutter-b my-5">
                        <div className="card-header border-0 pt-6">
                            <h3 className="col-8 card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.documentos_disponibles')}</span>
                            </h3>
                            <div className="row col-4 justify-content-end">
                                <div className="col-12">
                                    <div className="input-icon">
                                        <input onChange={(e)=>this.handleChange(e)} name="search"type="text" className="form-control" placeholder="Buscar" />
                                        <span>
                                            <i className="flaticon2-search-1 text-primary icon-md"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-5">
                            {this.state.onceDocuments.map((o, i) => {
                            return <div key={i}>
                                <div className="d-flex align-items-center py-2 mb-5">
                                    <div className="symbol symbol-40 symbol-white">
                                        <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                        <div className="checkbox-inline mr-5">
                                            <label className="checkbox checkbox-outline mb-7">
                                                <input key={o}
                                                name='list'
                                                type='checkbox'
                                                defaultChecked={this.isChecked(o)}
                                                onClick={(e)=>this.updateStateList(e,o)}
                                                label='Add'
                                                className='listTour'/>
                                                <span className="w-25px h-25px mt-2 rounded-0"></span>
                                            </label>
                                        </div>
                                        </span>
                                    </div>
                                    <div className="d-flex    flex-grow-1 my-lg-0 my-2 mr-2">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#844AFF" />
                                            <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519)" x="16.3255682" y="2.94551858" width="3" height="18" rx="1" />
                                        </g>
                                    </svg>
                                    <div className="d-flex flex-column ml-5">
                                    <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.document.fields.length > 0 && <span className="text-danger font-weight-bold">* </span> }{o.document.title} {o.document.fields.length > 0 && <span className="text-muted font-weight-normal">( {lang.get('messages.con_informacion_adicional')})</span> } </a>
                                    <span className="text-muted font-weight-bold"> Único |&nbsp;
                                        {
                                            o.document.mimes.map((mime, i, {length}) => {
                                                if (length - 1 === i) {
                                                    return mime.mime.toUpperCase()
                                                } else {
                                                    return mime.mime.toUpperCase() + ', '
                                                }
                                            })
                                        }
                                    </span>

                                    {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                    </div>

                                    </div>
                                    <a href={"/documents/" + o.id + "/edit"}>
                                        <button className="btn btn-icon btn-light btn-xs">
                                            <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                        </button>
                                    </a>
                                </div>
                            </div> })}
                            {this.state.totalOnce > this.state.maxRecords  &&
                                <SimplePagination
                                updateCurrentPage={this.updateCurrentPageOnce}
                                currentPage={this.state.pageOnce}
                                totalFiles={this.state.totalOnce}
                                split={this.state.maxRecords} />
                            }
                        </div>
                    </div>
                        }
                        <br />
                        <div className="text-center">
                            <button
                                className="btn btn-success font-weight-bolder px-10"
                                disabled={this.state.aditionalDocuments.length == 0}
                                onClick={() =>this.state.documentType == 'doc2sign' ? this.redirectToDoc2SignUploadWidget() : this.SetNotificationStatus()}
                            >
                                { this.state.documentType == 'doc2sign' ? lang.get('messages.subir_plantilla') + ' a Doc2Sign' : lang.get('messages.enviar_nueva_solicitud')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> {/* end modal */} 
        <SuspendRecurrencyModal ref={this.suspendRecurrencyModalRef} person_provider_id={this.props.person_provider_id} document_dossier_update_state={this.state.document_dossier_update_state} from_document_dossier_update_state={this.state.from_document_dossier_update_state} />
        <DeletePeriodsModal ref={this.deletePeriodsModalRef} person_provider_id={this.props.person_provider_id} />
        <DeletePersonDocumentsModal ref={this.deletePersonDocumentsRef} person_provider_id={this.props.person_provider_id} />
        <GeneratePeriodsModal ref={this.generatePeriodsModalRef} person_provider_id={this.props.person_provider_id} />
        <ReplaceDocumentTemplante ref={this.replaceDocumentTemplateRef} level="dossier" person_provider_id={this.props.person_provider_id} dossier_id={this.props.dossier_id} />                   
    </div>);
    }
}

export default DossierActions;

if (document.getElementById('DossierActions')) {
    ReactDOM.render(<DossierActions />, document.getElementById('DossierActions'));
}
